/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  // find all links that open new windows (outbound links and pdfs)
  $(document).on('click', 'a[target="_blank"]', function(event) {
    var url = $(this).attr('href')
    if (url.match(/\/uploads\//)) {
      trackFileDownload(url)
    } else {
      trackOutboundClick(url)
    }
  })
}

function getExtension(url) {
  var urlParts = url.match(/\.([a-z0-9]{3,4})$/i)
  if (urlParts) {
    return urlParts[1]
  }
  return false
}

function trackFileDownload(url) {
  send({
    eventCategory: 'Download',
    eventAction: getExtension(url),
    eventLabel: url,
  })
}

function trackOutboundClick(url) {
  send({
    eventCategory: 'Outbound Link',
    eventAction: 'Click',
    eventLabel: url,
  })
}

function send(eventObject) {
  console.info('sending analytics event', eventObject)

  // original ga
  window.ga && window.ga('send', 'event', eventObject)

  // new gtag
  window.gtag &&
    window.gtag('event', eventObject.eventAction, {
      event_category: eventObject.eventCategory,
      event_label: eventObject.eventLabel,
      value: eventObject.eventValue,
    })
}
